var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1666 4H5.83329C4.36263 4 3.16663 5.196 3.16663 6.66667V17.3333V18.6667V25.3333C3.16663 26.8053 4.36129 28 5.83329 28H27.1666C28.6386 28 29.8333 26.8053 29.8333 25.3333V18.6667V17.3333V6.66667C29.8333 5.196 28.6373 4 27.1666 4ZM25.8333 16H21.8333H21.644C21.0493 18.296 18.9813 20 16.5 20C14.0186 20 11.9506 18.296 11.356 16H11.1666H5.83329V6.66667H27.1666V16H25.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.498b9b99d0bbaa6c4612ed7930055cc9.svg";
export { ForwardRef as ReactComponent };